import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import NavBar from "../Components/NavBar/NavBar";
import Footer from "../Components/Footer/Footer";
import { Helmet } from "react-helmet";

const serviceDetails = [
  {
    title: "IT Consulting and Architecture Services",
    description:
      "We guide enterprises through digital transformation with future-ready IT strategies, optimizing performance, sustainability, and alignment with evolving technology landscapes.",
    image:
      "https://dam-cdn.atl.orangelogic.com/AssetLink/k7dar3781gw33380dt311lf663t4636m.webp",
    highlights: [
      "Digital transformation roadmaps",
      "Enterprise architecture design",
      "Sustainable IT operations",
    ],
  },
  {
    title: "Custom Software Design and Development",
    description:
      "We engineer customized software that solves specific business challenges and unlocks new value through intuitive design, scalability, and modern tech stacks.",
    image:
      "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860%20SunLife%20on%20Black%202x%201-2143605095.webp",
    highlights: [
      "Tailored enterprise apps",
      "Modern UI/UX",
      "Scalable backend solutions",
    ],
  },
  {
    title: "Mobile App Design and Development",
    description:
      "From concept to deployment, we craft seamless mobile apps for iOS and Android that engage users, streamline operations, and accelerate digital adoption.",
    image:
      "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-data-center-icon-3736035258.webp",
    highlights: [
      "Cross-platform expertise",
      "Native and hybrid apps",
      "App store optimization",
    ],
  },
  {
    title: "Enterprise Cloud Migration Support",
    description:
      "We enable smooth transitions to the cloud with minimal disruption, ensuring high performance, scalability, and secure infrastructure for your business.",
    image:
      "https://wac-cdn.atlassian.com/misc-assets/webp-images/community-bubble-icon-3561157108.webp",
    highlights: [
      "Cloud readiness assessment",
      "Migration execution",
      "Post-migration support",
    ],
  },
  {
    title: "On-Demand Skilled IT Staffing",
    description:
      "Access our global pool of vetted IT talent across domains like development, QA, infrastructure, and project management to fill urgent skill gaps.",
    image:
      "https://wac-cdn.atlassian.com/misc-assets/webp-images/gartner-jsw-left-img.webp",
    highlights: [
      "Flexible hiring models",
      "Global delivery",
      "Niche skill availability",
    ],
  },
];

const ServicesPage = () => {
  return (
    <div>
      <Helmet>
        <title>Our Services | Dhanam Information System</title>
      </Helmet>
      <NavBar />
      <section className="services-banner text-white text-center py-5">
        <h1 className="fw-bold">Explore Our Core Services</h1>
        <p className="lead">
          Building digital excellence through tailored IT and engineering
          solutions.
        </p>
      </section>

      <section className="py-5">
        <Container>
          {serviceDetails.map((service, index) => (
            <Row
              key={index}
              className={`align-items-center my-5 ${
                index % 2 !== 0 ? "flex-md-row-reverse" : ""
              }`}
            >
              <Col md={6} className="mb-4 mb-md-0">
                <img
                  src={service.image}
                  alt={service.title}
                  className="img-fluid rounded-4"
                />
              </Col>
              <Col md={6}>
                <h2
                  className="fw-bold mb-3"
                  style={{ color: "rgb(11, 22, 63)" }}
                >
                  {service.title}
                </h2>
                <p className="text-muted mb-3" style={{ lineHeight: "1.8" }}>
                  {service.description}
                </p>
                <ul className="ps-3">
                  {service.highlights.map((item, idx) => (
                    <li key={idx} className="mb-1">
                      {item}
                    </li>
                  ))}
                </ul>
              </Col>
            </Row>
          ))}
        </Container>
      </section>
      <Footer />

      <style jsx>{`
        .services-banner {
          background-color: rgb(11, 22, 63);
        }

        @media (max-width: 768px) {
          .services-banner h1 {
            font-size: 2rem;
          }
        }
      `}</style>
    </div>
  );
};

export default ServicesPage;
